import React, {useState} from "react";
import "./EditProfileFirstName.css";

const EditProfileFirstName = (props) => {
  const [nameOne, setNameOne] = useState('')

  const onInputChangeOne = (event) => {
    const firstName = event.target.value
    setNameOne(event.target.value)
    props.getFirstNameData(firstName);
  }

  const onSubmit = (event) => {
    event.preventDefault();

}

  return (
    <div className="edit-profile-first-name">
      <div className="first-name-h-eading">
        <div className="label-19 nunito-semi-bold-shuttle-gray-14px">First Name</div>
      </div>
      <input 
          onSubmit={onSubmit}
          className="first-name-input-field border-1px-mischka"
          type="text"
          name="firstName"
          value={nameOne}
          onChange={onInputChangeOne} 
      />
    </div>
  );
}

export default EditProfileFirstName;
